/* istanbul ignore file */
import { v4 as uuidv4 } from "uuid";
import { RapportageState } from "./infra/rapportage-schema";
import { User } from "oidc-client";

export const getReportDataForClipboardFromPowershell = (
  values: RapportageState,
  adviesdossier: string,
  voorstel: string | undefined | null,
  user: User | undefined | null,
  vestiging: string | undefined
): string => {
  const correlationId = uuidv4();
  const reportData = {
    $type:
      "Intersoftware.Platform.Foundation.Bus.Abstract.Models.NieuwRapport, Intersoftware.Platform.Foundation.Bus.Abstract",
    AdviesdossierId: adviesdossier,
    VoorstelId: voorstel,
    RapportStructuurId: values.structuurId,
    Preview: false,
    Bearer: `Bearer ${user?.access_token}`,
    VestigingId: vestiging
  };
  const jsonPayload = JSON.stringify(reportData, null, 2);

  const psCommand = `
$connectionString = $env:RAPPORT_CONNECTION_STRING
$connectionParts = $connectionString.Split(';') | ForEach-Object {
    $part = $_.Split('=', 2)
    @{($part[0]) = $part[1]}
}

$endpoint = $connectionParts.Endpoint.Replace("sb://", "https://")
$keyName = $connectionParts.SharedAccessKeyName
$keyValue = $connectionParts.SharedAccessKey
$entityPath = $connectionParts.EntityPath

$expiry = [string]([int64](([datetime]::UtcNow) - ([datetime]"1970-01-01")).TotalSeconds + 3600)
$stringToSign = [System.Web.HttpUtility]::UrlEncode($endpoint) + "\`n" + $expiry
$hmac = New-Object System.Security.Cryptography.HMACSHA256
$hmac.Key = [System.Text.Encoding]::UTF8.GetBytes($keyValue)
$signature = [System.Convert]::ToBase64String($hmac.ComputeHash([System.Text.Encoding]::UTF8.GetBytes($stringToSign)))
$sasToken = "SharedAccessSignature sr=" + [System.Web.HttpUtility]::UrlEncode($endpoint) + "&sig=" + [System.Web.HttpUtility]::UrlEncode($signature) + "&se=" + $expiry + "&skn=" + $keyName

$headers = @{
    "Authorization" = $sasToken
    "Content-Type" = "application/json"
    "BrokerProperties" = '{"CorrelationId": "${correlationId}"}'
}

Invoke-WebRequest -Uri "\${endpoint}\${entityPath}/messages" -Method POST -Headers $headers -Body '${jsonPayload.replace(
    /'/g,
    "''"
  )}'
`;

  return psCommand;
};
